import React from 'react'
import { Container } from 'react-bootstrap'
import { StaticQuery, graphql } from 'gatsby'
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import styled from 'styled-components'

class Seo extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            height: 0,
            width: 0
        }
    }
    updateDimensions = () => {
        if (this.state.height !== window.innerHeight) {
            this.setState({ height: window.innerHeight })
        }
        if (this.state.width !== window.innerWidth) {
            this.setState({ width: window.innerWidth })
        }
    }


    componentDidMount() {
        this.setState({ height: window.innerHeight, width: window.innerWidth })
        window.addEventListener('resize', this.updateDimensions)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions)
    }

    render() {

        const Section = styled.section`
            position: relative;            
            background-size: cover;
            background-repeat: no-repeat;
            background-color: #fffbe0;
            @media (max-width:767px) {
                background-size: 100%;                
            }
            @media (min-width: 1301px) and (max-width:1600px) {
                background-position-x: -110px;
            }
            @media (min-width:768px) and (max-width: 1300px) {    
                background-size: cover;
            }
        `

        const VideoContainer = styled.div`
            width: 100%;
            display: flex;
            align-items: center;
            overflow: hidden;
            position: relative;
            video {
                position: absolute;
            }            
        `

        const Heading1 = styled.h1`
            font-size: 80px;
            color: #ffffff;
            font-weight: 700;
            text-transform: uppercase;
            margin-top: 40px;
            -webkit-text-stroke-width: 3px;
            -webkit-text-stroke-color: #4285f4;;           
            @media (max-width:767px) {
                font-size: 35px;
                line-height: 35px;
                margin-top: 60px;
            }
            @media (min-width:768px) and (max-width:1500px) {
                font-size: 70px;
                margin-top: 50px;
            }
        `

        const Heading2 = styled.h2`
            font-size: 80px;
            font-family: Teko;
            line-height: 80px;
            color: #4285f4;
            font-weight: bold;            
            @media (min-width:768px) {
                margin-left: 4px;
            }            
            @media (min-width:768px) and (max-width:1500px) {
                font-size: 40px;
            }
            @media (max-width:767px) {
                margin-left: 2px;
                font-size: 20px;
                line-height: 20px;
            }
        `

        const Content = styled.div`
            position: relative;
            z-index: 10;
            @media (min-width:768px) and (max-width:1500px) {                
                margin-top: 100px;
            }
            @media (max-width:767px) {                
                margin-top: 100px;                
            }
        `

        const Separator = styled.div`
            height: 5px;
            width: 50px;
            background-color: #4285f4;
            margin-bottom: 30px;
            @media (min-width:768px) {
                margin-left: 6px;
            }
            @media (max-width:767px) {
                margin-left: 2px;
            }
        `

        const ServiceList = styled.ul`
            padding: 0;
            margin: 11px 0 0 0;
        `

        const ServiceListElement = styled.li`
            list-style: none;
            color: #000;
            font-weight: 300;
            font-size: 20px;
            margin: 5px 0px;
            &::before {
                display: inline-block;
                content: '';
                border-radius: 2.5px;
                height: 5px;
                width: 5px;
                margin-right: 10px;
                background-color: #4285f4;
                position: relative;
                bottom: 2.5px;
            }
        `

        const Color1 = styled.span`
            color: #ea4335;            
        `

        const Color2 = styled.span`
            color: #fbbc05;            
        `

        const Color3 = styled.span`
            color: #34a853;            
        `

        const { data } = this.props;
        const imageData = getImage(data.background.childImageSharp.gatsbyImageData);

        return (
            <Section>
                <VideoContainer style={{ height: `${this.state.width > 500 ? this.state.height : 450}px` }}>
                    <GatsbyImage
                        image={imageData}
                        alt="SEO VASCO Solutions"
                        style={{ position: 'absolute', width: '110%', height: '100%', opacity: 0.8 }}
                    />
                    <Container>
                        <Content>
                            <Heading1>
                                Servicios SEO en Colombia: Posiciona tu Negocio en Google con VASCO Solutions
                            </Heading1>
                            <Separator />
                            <Heading2>
                                Search Engine Optimization
                            </Heading2>
                            <ServiceList>
                                <ServiceListElement>
                                    30 Backlinks White hat (Sombrero blanco)
                                </ServiceListElement>
                                <ServiceListElement>
                                    DA 81-99
                                </ServiceListElement>
                                <ServiceListElement>
                                    Sitios de autoridad masiva seleccionados
                                </ServiceListElement>
                                <ServiceListElement>
                                    Backlinks manuales
                                </ServiceListElement>
                                <ServiceListElement>
                                    Entrega en 30 días
                                </ServiceListElement>
                            </ServiceList>
                        </Content>
                    </Container>
                </VideoContainer>
            </Section>
        )
    }
}

const Background = () => (
    <StaticQuery
        query={graphql`
            {
                background: file(relativePath: { eq: "seo.jpg" }) {
                    childImageSharp {
                        gatsbyImageData(layout: CONSTRAINED, width: 2000)
                    }
                }
            }
        `}
        render={data => <Seo data={data} />}
    />
);

export default Background;
